import Button from "@dustin-web/microsite-components/src/button"
import { useSiteContext, useTranslations, useUserSettings } from "@dustin-web/microsite-components/src/hooks"
import { GaRegEvent } from "../gaRegistrationHook/gaRegistrationEventHook"
import { useAuth } from "@dustin-web/microsite-components/src/auth"
import { useContext } from "react"
import AppContext from "src/appContext"

const Confirmation = () => {
  const { translate } = useTranslations()
  const { loginRegisterCompleteGaEvent } = GaRegEvent()
  const { signIn } = useAuth()
  const { siteType } = useSiteContext()
  const { returnUrl } = useContext(AppContext)
  const { twoLetterISOLanguageName } = useUserSettings()
  const handleOnLoginClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    loginRegisterCompleteGaEvent()
    signIn({
      cancellationUrl: window.location.origin,
      provider: 'okta',
      siteType: siteType === 'Business' ? 'business' : 'consumer',
      username: '',
      returnUrl: returnUrl ?? window.location.origin,
      language: twoLetterISOLanguageName,
    })
  }
  
  return (
    <div className="row">
      <div className="col">
        <Button
          className="u-w-100 u-w-lg-auto"
          primary
          text={translate("Register_UsernameAlreadyExists_Login")}
          icon={'log-in'}
          onClick={handleOnLoginClick}
        />
      </div>
    </div>
  )
}

export default Confirmation
